"use client";

import { useEffect } from "react";
import ErrorPage from "@/components/entities/error";
import { useTranslations } from "next-intl";

export default function Error({ error }: { error: Error & { digest?: string }}) {
  const t = useTranslations();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return <ErrorPage title={t("error.wrong")} text={error.message} />;
}
